module.exports = __webpack_public_path__ + "img/Loading.52113ebd.png";